import { render, staticRenderFns } from "./TeamPlayers.vue?vue&type=template&id=4b4db0b4&scoped=true"
import script from "./TeamPlayers.vue?vue&type=script&lang=js"
export * from "./TeamPlayers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4db0b4",
  null
  
)

export default component.exports